import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-wizzard-errors',
    templateUrl: './wizzard-errors.shared.component.html',
    styleUrls: ['./wizzard-errors.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizzardErrorsComponent implements OnInit {
    @Input() public limit: number;

    public errors$: Observable<string[]>;

    constructor(
        public controllers: Controllers,
        public wizzardService: Services.WizzardService,
    ) { }

    ngOnInit(): void {
        this.errors$ = this.controllers.wizzard.getWizzardErrorsMessages$(this.limit || 1);
    }

    public trackBy(error: State.IWizzardError, index: number): number {
        return index;
    }
}
